module.exports = __webpack_public_path__ + "static/media/szpital.fc7f7b2e.svg";